import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import app from '../main';
import * as http from 'http'

// axios.defaults.withCredentials = true;
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = 'http://localhost:8080, https://dev-kioskportal.etnersplatform.com, https://ds.eskiosk.com, http://172.16*';

// 1. HTTP Request & Response와 관련된 기본 설정

const ApiUtil = {
  init () {
    Vue.use(VueAxios, axios)
    Vue.axios.interceptors.request.use(
        function (config){
          app.$Progress.plus()
          return config
        }
    )
    Vue.axios.interceptors.response.use(
        function (config){
          app.$Progress.minus()
          return config
        },
        function (error) {
          app.$Progress.minus()
          return error;
        }
    )
  },

  query (resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[ApiService]\nerror: ${error} \nresource: ${resource}\nparams: ${params}`)
    })
  },

  get (resource, slug = '') {
    let url = `${resource}/${slug}`

    if (slug == '') {
      url = `${resource}`
    }

    const config = {
      headers: {
        lutk: sessionStorage.getItem('loginUserToken')
      }
    }

    return Vue.axios.get(url, config).catch(error => {
      throw new Error(`[ApiService]\nerror: ${error} \nurl: ${url}`)
    })
  },

  post (resource, params, options = { isShowLoadingBar : true }) {
    if (Vue == undefined || Vue.axios == undefined) {
      return axios.post(`${resource}`, params)
    } else if(!options?.isShowLoadingBar){
      return axios.create().post(`${resource}`, params)
    } else {
      return Vue.axios.post(`${resource}`, params)
    }
  },

  postIncludeUploadFile (resource, formData) {
    return Vue.axios.post(`${resource}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  }
}

export default ApiUtil
